import React, { useState, useEffect } from "react";
import { ReactSelectAdapter } from "../../reuseableComponents/forms/ReactSelectAdapter";
import { Row, Col } from "react-bootstrap";
import ButtonPill from "../../reuseableComponents/buttons/ButtonPill";
import ButtonSubmit from "../../reuseableComponents/buttons/ButtonSubmit";
import ButtonProcessing from "../../reuseableComponents/buttons/ButtonProcessing";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { Form, Field } from "react-final-form";
import {
  LOAD_USER_PROFILE_PAGE_DATA,
  GET_USER_FAVORITE_REPORTS,
  ADD_FAVORITE_REPORT,
  DELETE_FAVORITE_REPORT
} from "../../../queries/archiveQrys/secureQrys/userProfileQrys";
import { useQuery, useMutation } from "@apollo/client";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";

const UserProfileFavoriteReports = (umdId) => {
  const [favoritesLoaded, setFavoritesLoaded] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [favorites, setFavorites] = useState([]);
  const [favoritesSelectList, setFavoritesSelectList] = useState([]);

  const updateFavoritesSelectList = (favoritesList, allWaterlinkReports) => {
    var result = allWaterlinkReports.filter(function (o1) {
      return !favoritesList.some(function (o2) {
        return o1.value === o2.reportId;
      });
    });
    setFavoritesSelectList(result);
  };

  const { loading, error, data } = useQuery(LOAD_USER_PROFILE_PAGE_DATA, {
    variables: umdId,
    onCompleted: (data) => {
      setFavorites(data.getUserFavoriteReportsByUmdId);
      updateFavoritesSelectList(data.getUserFavoriteReportsByUmdId, data.getAllWaterlinkReports);
      setFavoritesLoaded(true);
      setisLoading(false);
    }
  });

  const [addNewFavoriteReportMutation, addResults] = useMutation(ADD_FAVORITE_REPORT, {
    refetchQueries: [{ query: GET_USER_FAVORITE_REPORTS, variables: umdId }],
    awaitRefetchQueries: true
  });

  const [deleteFavoriteReportMutation, deleteResults] = useMutation(DELETE_FAVORITE_REPORT, {
    refetchQueries: [{ query: GET_USER_FAVORITE_REPORTS, variables: umdId }],
    awaitRefetchQueries: true
  });

  const onSubmit = (submit, form) => {
    let currentFavoriteReports = data.getUserFavoriteReportsByUmdId;

    // Don't add report to the list if it already exists. To prevent duplicate keys.
    if (
      currentFavoriteReports.some(function (o) {
        return o["reportId"] === submit.reportCode.value;
      })
    ) {
      alert("This report is already on your list.");
    } else {
      setisLoading(true);
      addNewFavoriteReportMutation({
        variables: {
          umdId: umdId.umdId,
          reportId: submit.reportCode.value
        }
      });
    }

    form.reset();
  };

  const deleteReport = (reportId) => {
    setisLoading(true);
    deleteFavoriteReportMutation({
      variables: {
        umdId: umdId.umdId,
        reportId: reportId
      }
    });
  };

  useEffect(() => {
    if (data && data.getUserFavoriteReportsByUmdId !== undefined) {
      setFavorites(data.getUserFavoriteReportsByUmdId);
    }
  }, [data, deleteResults, addResults, favorites]);

  function showReportButtons(defaultFavoriteReports) {
    return !isLoading ? (
      <ButtonPill key={defaultFavoriteReports.reportId} id='ddw-primary' label={defaultFavoriteReports.reportName}>
        <FontAwesomeIcon
          className='font-icon'
          icon={faTimesCircle}
          onClick={() => deleteReport(defaultFavoriteReports.reportId)}
        />
      </ButtonPill>
    ) : (
      <ButtonPill key={defaultFavoriteReports.reportId} id='ddw-tertiary' label={defaultFavoriteReports.reportName}>
        <FontAwesomeIcon className='font-icon' icon={faTimesCircle} />
      </ButtonPill>
    );
  }

  if (error) {
    return (
      <>
        <Row>
          <Col>
            <h3>Favorite Modules</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <ErrorHandler error={error} />
          </Col>
        </Row>
      </>
    );
  }
  if (loading && !favoritesLoaded) {
    return (
      <>
        <Row>
          <Col>
            <h3>Favorite Modules</h3>
          </Col>
        </Row>
        <Row>
          <Col>
            <SkeletonLoader />
          </Col>
        </Row>
      </>
    );
  }
  return (
    <>
      <Row>
        <Col>
          <h3>Favorite Modules</h3>
        </Col>
      </Row>
      <Row>
        <Col>
          <Form
            onSubmit={onSubmit}
            initialValues={{ umdId: umdId }} //Removed initValues that were set for reportCode. Unecessary since you're not populating a value in that field on load
            render={({ handleSubmit, form, submitting, values }) => (
              <form onSubmit={handleSubmit}>
                <Row>
                  <Col>
                    <Field
                      name='reportCode'
                      component={ReactSelectAdapter}
                      options={favoritesSelectList}
                      className='m-2'
                      placeholder='Select a Report ...'
                    />
                  </Col>
                  <Col>
                    {!isLoading ? (
                      <ButtonSubmit id='ddw-primary' label='Add Report' disabled={!values.reportCode}></ButtonSubmit>
                    ) : (
                      <ButtonProcessing id='ddw-primary' disabled />
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className='error'>{addResults.error ? addResults.error.message : ""}</span>
                    <span className='error'>{deleteResults.error ? deleteResults.error.message : ""}</span>
                  </Col>
                </Row>
                <br />
              </form>
            )}
          />
        </Col>
      </Row>
      {favorites ? (
        <Row>
          <Col>{favorites.map(showReportButtons, this)}</Col>
        </Row>
      ) : (
        ""
      )}
    </>
  );
};

export default UserProfileFavoriteReports;
